/**
 * Scoped admin overview (index page for /c/:chapterSlug/admin and
 * /c/:chapterSlug/b/:branchSlug/admin).
 *
 * Light landing surface — shows the active scope and quick links into
 * the admin areas the sidebar gates by permission.
 */

import { useScope } from '@/contexts/ScopeContext';

export function ScopedAdminOverview() {
  const { chapter, branch } = useScope();
  return (
    <section className="card">
      <h1 className="text-2xl font-display font-bold text-white mb-2">Admin overview</h1>
      <p className="text-white/70">
        You're managing{' '}
        <span className="font-semibold text-white">
          {branch?.displayName ?? branch?.name ?? chapter?.displayName}
        </span>
        .
      </p>
      <p className="text-white/60 mt-3 text-sm">
        Pick an area on the left. Items you can't act on are hidden by your scope role.
      </p>
    </section>
  );
}

export default ScopedAdminOverview;
